export const serviceGuide = {
  fr: {
    title: 'Votre projet web de A à Z : méthode et clarté',
    intro: 'Que vous soyez artisan, profession libérale, commerce ou PME, nous définissons avec vous l’architecture et les fonctionnalités adaptées à vos objectifs réels de croissance.',
    sections: [
      {
        title: 'Choisir le périmètre adapté à votre activité',
        text: 'Pour valoriser votre savoir-faire et capter des demandes de devis, un site vitrine structuré est idéal. Pour la vente en ligne, nous intégrons un catalogue fluide et un paiement sécurisé. En cas de refonte, nous préservons vos acquis SEO et mettons en place les redirections nécessaires.',
      },
      {
        title: 'Un budget transparent et sans mauvaise surprise',
        text: 'Nos propositions détaillent l’ensemble des prestations : nombre de pages, direction artistique, fonctionnalités, hébergement et calendrier. Vous savez exactement où va chaque euro investi, sans frais cachés ni abonnement imposé.',
      },
      {
        title: 'Des contenus percutants taillés pour convaincre',
        text: 'Nous structurons vos arguments, vos réalisations et vos preuves de confiance pour répondre immédiatement aux questions de vos prospects. Chaque page est pensée pour rassurer et déclencher la prise de contact.',
      },
      {
        title: 'Lancement, optimisation continue et suivi du ROI',
        text: 'Avant la mise en ligne, nous validons la rapidité mobile, les formulaires et le balisage sémantique. Dès le lancement, nous configurons le suivi des performances pour mesurer l’impact réel sur votre visibilité.',
      },
    ],
    cta: 'Échanger sur votre projet',
    resources: 'Ressources & Guides SEO',
  },
  en: {
    title: 'Your website project from A to Z: method and clarity',
    intro: 'Whether you are a craftsman, professional, retailer or SME, we define with you the architecture and features tailored to your real growth objectives.',
    sections: [
      {
        title: 'Define the scope tailored to your business',
        text: 'A structured showcase website presents your services and captures qualified quote requests. An online store adds smooth product management and secure checkout. For a redesign, we preserve your existing SEO rankings.',
      },
      {
        title: 'Transparent budget with zero hidden surprises',
        text: 'Our proposals detail the scope: page count, art direction, features, hosting and timeline. You know exactly where every euro goes, with zero hidden costs or forced subscriptions.',
      },
      {
        title: 'Compelling content built to convert',
        text: 'We organize your value proposition, customer testimonials and evidence of craftsmanship to address client questions directly and trigger inquiries.',
      },
      {
        title: 'Launch, continuous optimization and ROI tracking',
        text: 'Before deployment, we verify mobile speed, form delivery and semantic markup. Post-launch, we configure Search Console and tracking to measure real visibility growth.',
      },
    ],
    cta: 'Discuss your project',
    resources: 'Resources & SEO Guides',
  },
  ar: {
    title: 'مشروع موقعك من البداية حتى الإطلاق: وضوح ومنهجية',
    intro: 'سواء كنت صاحب مهنة حرة أو متجراً أو شركة، نحدد معك الهيكلية والوظائف المصممة خصيصاً لأهداف نموك الحقيقية.',
    sections: [
      {
        title: 'تحديد النطاق المناسب لنشاطك',
        text: 'موقع تعريفي احترافي لإبراز خبرتك وجذب طلبات الأسعار المؤهلة. ومتجر إلكتروني بمعالجة دفع آمنة وسلسة. وفي حال إعادة التصميم نحافظ على مراكزك في محركات البحث.',
      },
      {
        title: 'ميزانية شفافة وبدون مفاجآت خفية',
        text: 'عروضنا توضح كافة التفاصيل: عدد الصفحات، التصميم، الميزات، الاستضافة والجدول الزمني، بدون اشتراكات إجبارية.',
      },
      {
        title: 'محتوى مؤثر مصمم للإقناع',
        text: 'نرتب نقاط قوتك ونماذج أعمالك للإجابة عن تساؤلات عملائك وتحفيزهم على التواصل الفوري.',
      },
      {
        title: 'الإطلاق ومتابعة العائد على الاستثمار',
        text: 'نتحقق من السرعة على الهواتف والنماذج والبيانات المنظمة قبل الإطلاق، ثم نتابع أداء الظهور الفعلي.',
      },
    ],
    cta: 'ناقش مشروعك معنا',
    resources: 'الموارد ودليل السيو',
  },
};
